import React from 'react';
import { TableBody as MuiTableBody, type TableBodyProps } from '@mui/material';

export type DataBodyProps = TableBodyProps;

export default function DataBody({ children, ...props }: DataBodyProps) {
  return <MuiTableBody {...props}>{children}</MuiTableBody>;
}
